import React from "react";
import { AppBar, Toolbar, IconButton, Typography, Container } from '@mui/material';
import Menu from "./Menu"

// const useStyles = makeStyles((theme) => ({
//     root: {
//         display: "flex",
//     },
//     toolbar: {
//         paddingRight: 24, // keep right padding when drawer closed
//     },
//     toolbarIcon: {
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "flex-end",
//         padding: "0 8px",
//         ...theme.mixins.toolbar,
//     },
//     appBar: {
//         zIndex: theme.zIndex.drawer + 1,
//         transition: theme.transitions.create(["width", "margin"], {
//             easing: theme.transitions.easing.sharp,
//             duration: theme.transitions.duration.leavingScreen,
//         }),
//         backgroundColor: "black"
//     },
//     appBarShift: {
//         transition: theme.transitions.create(["width", "margin"], {
//             easing: theme.transitions.easing.sharp,
//             duration: theme.transitions.duration.enteringScreen,
//         }),
//     },
//     menuButton: {
//         marginRight: 36,
//     },
//     menuButtonHidden: {
//         display: "none",
//     },
//     title: {
//         flexGrow: 1,
//         color: "#ffffff"
//     },
//     drawerPaper: {
//         position: "relative",
//         whiteSpace: "nowrap",
//         transition: theme.transitions.create("width", {
//             easing: theme.transitions.easing.sharp,
//             duration: theme.transitions.duration.enteringScreen,
//         }),
//     },
//     appBarSpacer: theme.mixins.toolbar,
//     content: {
//         flexGrow: 1,
//         height: "100vh",
//         overflow: "auto",
//         background: "white",
//     },
//
// }));

export default function ShowTask(props) {
    // const classes = useStyles()
    return (
        <>
            <AppBar>
                {/*<AppBar className={classes.appBar}>*/}
                <Toolbar>
                    <Typography variant="h6">
                        {/*<Typography variant="h6" className={classes.title}>*/}
                        MENU
                    </Typography>

                    <IconButton edge="start" color="inherit" onClick={props.handleClose} aria-label="close">
                        X
                    </IconButton>
                </Toolbar>
            </AppBar>

                <Container maxWidth="lg">
                    {/*<Container maxWidth="lg" className={classes.container}>*/}

                <div className="mt-10">
                    <div className="d-lg-block text-center mb-5">
                        <Menu />
                    </div>

                </div>
            </Container>
        </>
    )

}
